<app-lms-modal-frame [title]="'Banking Details'" [pageHeadWidth]="600">
  <div modal-body>
    <div class="container-fluid center-screen">
      <form [formGroup]="bankDetailsForm" >
          <table w650 id="clientHeader" class="table p-1 table-hover table-sm shadow-2-strong rounded-1">
            <caption>Client Details</caption>
            <tbody>
              <tr>
                <td>First names</td>
                <td>{{clientDetails.firstName}}</td>

                <td>Surname</td>
                <td>{{clientDetails.lastName}}</td>
              </tr>

              <tr>
                <td>ID number</td>
                <td>{{clientDetails.idNumber}}</td>

                <td>Cell number</td>
                <td>{{clientDetails.cellNumber}}</td>
              </tr>
            </tbody>
          </table>

          <div class="row center-screen">
            <!-- VIEW MODE - When accounts exist and not editing -->
            <div *ngIf="hasAccount && !isEditing">
              <table class="mt-2 mb-0 table table-borderless table-sm table-auto" [style.width.px]="750">
                <tbody>
                  <tr>
                    <td class="aligndetails" style="border-bottom-width: 0;">
                      <table class="table table-striped table-sm shadow-2-strong rounded-1">
                        <caption>
                          Collect Account details
                        </caption>
                        <tbody class="field-4column-label">
                          <tr>
                            <td>Account holder</td>
                            <td>{{bankDetailsModel.colAccountHolder}}</td>
                          </tr>
                          <tr>
                            <td>Account number</td>
                            <td>{{bankDetailsModel.colAccountNumber}}</td>
                          </tr>
                          <tr>
                            <td>Account type</td>
                            <td>{{bankDetailsModel.colAccountType}}</td>
                          </tr>
                          <tr>
                            <td>Bank</td>
                            <td>{{bankDetailsModel.colBank}}</td>
                          </tr>
                          <tr>
                            <td>Branch Code</td>
                            <td>{{bankDetailsModel.colBranchCode}}</td>
                          </tr>
                          <tr>
                            <td>Account loan type</td>
                            <td>{{bankDetailsModel.colAccountLoanType}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>

                    <td class="aligndetails" style="border-bottom-width: 0;">
                      <!-- Disburse Account -->
                      <table id="disburseAccount" class="table table-striped table-sm shadow-2-strong rounded-1">
                        <caption>
                          Disburse Account details
                        </caption>
                        <tbody class="field-4column-label">
                          <tr>
                            <td>Account holder</td>
                            <td>{{bankDetailsModel.accountHolder}}</td>
                          </tr>
                          <tr>
                            <td>Account number</td>
                            <td>{{bankDetailsModel.accountNumber}}</td>
                          </tr>
                          <tr>
                            <td>Account type</td>
                            <td>{{bankDetailsModel.accountType}}</td>
                          </tr>
                          <tr>
                            <td>Bank</td>
                            <td>{{bankDetailsModel.bank}}</td>
                          </tr>
                          <tr>
                            <td>Branch Code</td>
                            <td>{{bankDetailsModel.branchCode}}</td>
                          </tr>
                          <tr>
                            <td>Account loan type</td>
                            <td>{{bankDetailsModel.accountLoanType}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- EDIT MODE - When editing existing accounts or creating new ones -->
            <div *ngIf="isEditing || !hasAccount">
              <div class="row center-screen">
                <table class="mt-0 mb-0 table table-sm table-fixed" [style.width.px]="750">
                <tbody>
                  <!-- sameAccount-->
                  <tr *ngIf="bankDetailsModel.sameAsDisburseAccount === true">
                    <!-- Disburse and Collection Account -->
                    <td [colSpan]="2" class="aligndetails" style="border-bottom-width: 0;">
                      <table class="table p-1 table-striped table-bordered table-sm shadow-2-strong rounded-1 w-50">
                        <caption>Collection and Disburse Account</caption>
                        <tbody class="field-4column-label">
                          <tr>
                            <td>Bank</td>
                            <td>
                              <mdb-select class="select table-control" formControlName="collect_bank"
                                placeholder="Select a bank" required
                                (change)="onColBankSelect($event.target)">
                                <mdb-option *ngFor="let bank of debiCheckBanks" [value]="bank.bankName">
                                  {{bank.bankName}}
                                </mdb-option>
                              </mdb-select>
                              <div *ngIf="collect_bank?.errors?.required && submitted">
                                <small class="text-danger">
                                  Please select bank name
                                </small>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>Branch code</td>
                            <td>{{bankDetailsModel.colBranchCode}}</td>
                          </tr>

                          <tr>
                            <td>Account holder</td>
                            <td>
                              <input class="form-control" formControlName="collect_accountHolder"
                                placeholder="Account holder" type="text" required
                                lmsNoSpecials (keypress)="!($event.charCode >= 48 && $event.charCode < 58)">
                              <div *ngIf="collect_accountHolder?.errors?.required && submitted">
                                <small class="text-danger">
                                  Account holder is required
                                </small>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>Account number</td>
                            <td>
                              <input class="form-control" placeholder="Account number"
                                formControlName="collect_accountNumber" required
                                type="numbers" maxlength="19" lmsNumbersOnly [allowDecimals]="false"
                                [allowPaste]="false">
                              <div *ngIf="collect_accountNumber?.errors?.required && submitted">
                                <small class="text-danger">
                                  Account number is required
                                </small>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>Account type</td>
                            <td>
                              <mdb-select class="select table-control" formControlName="collect_accountType"
                                required>
                                <mdb-option value="CHEQUE">Cheque</mdb-option>
                                <mdb-option value="SAVINGS">Savings</mdb-option>
                              </mdb-select>
                              <div *ngIf="collect_accountType?.errors?.required && submitted">
                                <small class="text-danger">
                                  Account type is required
                                </small>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- NOT sameAccount-->
                  <tr *ngIf="!bankDetailsModel?.sameAsDisburseAccount">
                    <!-- Collection Account -->
                    <td class="aligndetails" style="border-bottom-width: 0;">
                      <table class="table p-1 table-striped table-bordered table-sm shadow-2-strong rounded-1">
                        <caption>
                          Collect Account
                        </caption>

                        <tbody class="field-4column-label">
                          <tr>
                            <td>Bank</td>
                            <td>
                              <mdb-select class="select table-control" formControlName="collect_bank"
                                (change)="onColBankSelect($event.target)" required>
                                <mdb-option *ngFor="let bank of debiCheckBanks" [value]="bank.bankName">
                                  {{bank.bankName}}
                                </mdb-option>
                              </mdb-select>
                              <div *ngIf="collect_bank?.errors?.required && submitted">
                                <small class="text-danger">
                                  Please select bank name
                                </small>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>Branch code</td>
                            <td>{{bankDetailsModel.colBranchCode}}</td>
                          </tr>

                          <tr>
                            <td>Account holder</td>
                            <td>
                              <input class="form-control" class="form-control"
                                formControlName="collect_accountHolder"
                                placeholder="Account holder" required type="text" lmsNoSpecials
                                (keypress)="!($event.charCode >= 48 && $event.charCode < 58)">
                              <div *ngIf="collect_accountHolder?.errors?.required && submitted">
                                <small class="text-danger">
                                  Account holder is required
                                </small>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>Account number</td>
                            <td>
                              <input class="form-control" placeholder="Account number"
                                formControlName="collect_accountNumber" type="text"
                                maxlength="19" required lmsNumbersOnly [allowDecimals]="false" [allowPaste]="false">
                              <div *ngIf="collect_accountNumber?.errors?.required && submitted">
                                <small class="text-danger">
                                  Account number is required
                                </small>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>Account type</td>
                            <td>
                              <mdb-select class="select table-control" aria-placeholder="Select type"
                                formControlName="collect_accountType" required>
                                <mdb-option value="CHEQUE">Cheque</mdb-option>
                                <mdb-option value="SAVINGS">Savings</mdb-option>
                              </mdb-select>
                              <div *ngIf="collect_accountType?.errors?.required && submitted">
                                <small class="text-danger">
                                  Account type is required
                                </small>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>

                    <!-- Disburse Account -->
                    <td class="aligndetails" style="border-bottom-width: 0;">
                      <table class="table p-1 table-striped table-bordered table-sm shadow-1-strong rounded-1">
                        <caption>Disburse Account</caption>

                        <tbody class="field-4column-label">
                          <tr>
                            <td>Bank</td>
                            <td>
                              <mdb-select class="select table-control" formControlName="bank"
                                required
                                (change)="onBankSelect($event.target)">
                                <mdb-option *ngFor="let bank of allBanks" [value]="bank.bankName">{{bank.bankName}}
                                </mdb-option>
                              </mdb-select>
                              <div *ngIf="bank?.errors?.required && submitted">
                                <small class="text-danger">
                                  Please select bank name
                                </small>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>Branch code</td>
                            <td>
                              {{bankDetailsModel.branchCode}}
                            </td>
                          </tr>

                          <tr>
                            <td>Account holder</td>
                            <td style="width: 120px;">
                              <input class="form-control" formControlName="accountHolder"
                                placeholder="Account holder" type="text" required
                                lmsNoSpecials (keypress)="!($event.charCode >= 48 && $event.charCode < 58)">
                              <div *ngIf="accountHolder?.errors?.required && submitted">
                                <small class="text-danger">
                                  Account holder is required
                                </small>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>Account number</td>
                            <td>
                              <input class="form-control" placeholder="Account number"
                                formControlName="accountNumber" type="numbers"
                                maxlength="19" required lmsNumbersOnly [allowDecimals]="false" [allowPaste]="false">
                              <div *ngIf="accountNumber?.errors?.required && submitted">
                                <small class="text-danger">
                                  Account number is required
                                </small>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td> Account type</td>
                            <td>
                              <mdb-select class="select table-control" formControlName="accountType"
                                required>
                                <mdb-option value="CHEQUE">Cheque</mdb-option>
                                <mdb-option value="SAVINGS">Savings</mdb-option>
                              </mdb-select>
                              <div *ngIf="accountType?.errors?.required && submitted">
                                <small class="text-danger">
                                  Account type is required
                                </small>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
                <div class="d-flex justify-content-center my-2">
                  <div class="form-check-reverse check-end form-check-inline my-1">
                  <input mdbCheckbox id="sameAsDisburseAccount" formControlName="sameAsDisburseAccount"
                  [checked]="bankDetailsModel.sameAsDisburseAccount" (checkboxChange)="onSameAccountChange()" class="form-check-input" type="checkbox" />
                  <label class="form-check-label px-2" for="sameAsDisburseAccount">
                    Disburse account is the same as the Collection account
                  </label>
                </div>
              </div>
              </div>
            </div>

            <div class="payout-method-row d-flex justify-content-center align-items-center my-1">
              <label class="w-25" for="payoutMethod">Payout Method</label>
              <mdb-select class="form-select w-25 pull-right select table-control" formControlName="payoutMethod" required>
                <mdb-option *ngIf="bankDetailsModel.sameAsDisburseAccount ? collect_bank?.value !== 'Finbond Mutual Bank' : bank?.value !== 'Finbond Mutual Bank'" [value]="'CBS BANK TRANSFER'">CBS BANK TRANSFER</mdb-option>
                <mdb-option *ngIf="bankDetailsModel.sameAsDisburseAccount ? collect_bank?.value === 'Finbond Mutual Bank' : bank?.value == 'Finbond Mutual Bank'" [value]="'FINBOND CARD'">
                  Finbond Card
                </mdb-option>
                <mdb-option value="CASH">Cash</mdb-option>
              </mdb-select>
            </div>
          </div>

      </form>
    </div>
  </div>
  <div modal-actions class="lms-action-footer">
    <button type="button" class="btn btn-primary" mdbRipple (click)="close()">Close</button>
    <button type="button" class="btn btn-primary" mdbRipple *ngIf="!isReadOnly && !hasAccount" (click)="saveBankDetails()">Save</button>
    <button type="button" class="btn btn-primary" mdbRipple *ngIf="hasAccount && !isReadOnly" (click)="editBankDetails()">{{ isEditing ? 'Save' : 'Edit' }}</button>
  </div>
</app-lms-modal-frame>

